import { useMemo } from 'react'
import { aDrawnFeature, aMapViewState, useAtomValue } from '~/atoms'

export default function useSearchLocation() {
  const mapViewState = useAtomValue(aMapViewState)
  const drawnFeature = useAtomValue(aDrawnFeature)

  return useMemo(() => {
    if (drawnFeature) {
      const isCircle =
        'properties' in drawnFeature &&
        drawnFeature.properties &&
        'isCircle' in drawnFeature.properties
          ? 'true'
          : 'false'

      return {
        $geoWithin: {
          $geometry: {
            ...drawnFeature.geometry,
            properties: {
              ...drawnFeature.properties,
              isCircle,
            },
          },
        },
      }
    } else if (mapViewState) {
      const ne = Object.values(mapViewState!.bounds.getNorthEast())
      const sw = Object.values(mapViewState!.bounds.getSouthWest())

      return {
        $geoWithin: {
          $geometry: {
            type: 'Polygon',
            coordinates: [
              [
                [sw[0], ne[1]],
                [ne[0], ne[1]],
                [ne[0], sw[1]],
                [sw[0], sw[1]],
                [sw[0], ne[1]],
              ],
            ],
          },
        },
      }
    }

    return {}
  }, [drawnFeature, mapViewState])
}
